export default {
  template: '#vue-footer-component',
  delimiters: ['${', '}'],
  data: function () {
    return {
      nav_open_state: []
    }
  },
  methods: {
    toggleNav: function (id) {
      let navPos = this.nav_open_state.indexOf(id);
      if (navPos > -1) {
        this.nav_open_state.splice(navPos, 1);
      } else {
        this.nav_open_state.push(id);
      }
    }
  }
}